import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Checkbox from '@material-ui/core/Checkbox';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import {extractData} from '../../util/TableUtil'
import { styles } from '../CSS/Styles'


class ActionPlan extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value:0,
            filter: [],
            isFilterByStatus: false,
            isFilterByType: false,
            isFilterByRisk: false
        }
    }

    componentDidMount(){
    }

    componentWillMount() {
        //this.setState(getState());
        //setInterval(() => {
        //    this.setState(getState());
        //}, 4000);
        this.getFilter()
    }

    handleChange = name => event => {
        this.setState({ [name]: event.target.checked })
    };

    getFilter() {
        let filterData = {
            'Risk': ['R1', 'R2', 'R3', 'R4', 'R5', 'R6', 'R7', 'R8', 'R9'],
        }
        this.setState( { filter: filterData } )
        for (let val in filterData) {
            let data = filterData[val]
            for (let filter in data){
                this.setState({ [data[filter]]: true })
            }
        }
    }

    render() {
        const { classes } = this.props;

        const filters = ()=>{
            let filterJSX = []
            for (var filter in this.state.filter) {
                filterJSX.push(
                    <div style={{ textAlign: 'left', paddingLeft: '10px'}}>
                        <typography style={{ display: 'inline-block', minWidth: '120px'}}> {filter} : </typography>
                        {this.state.filter[filter].map((data)=>{
                            return (
                                <div style={{display:'inline-block', textAlign:'left', minWidth:'120px'}}>
                                    <Checkbox
                                        checked={this.state[data]}
                                        onChange={this.handleChange(data)}
                                        value={data}
                                        color='primary'
                                    />
                                    <typography> {data} </typography>
                                </div>
                            )
                        })}
                    </div>
                )
            }
            return filterJSX
        }
        const filterheader = filters();

        let data = this.props.data
        const headers = ['No', 'Risk', 'Lead Risk Owners', 'No ', 'Very Low', 'Low', 'Medium', 'High', 'Risk Appetite Statement']
        const dbheader = ['risk_name', 'risk_name', 'owners', 'no_appetite', 'very_low_appetite', 'low_appetite', 'medium_appetite', 'high_appetite', 'risk_appetite_statements']

        let tableData = extractData(data, headers, dbheader)
        console.log(tableData)

        const table =  (
            <Table>
                <TableHead>
                    <TableRow style={{height:'40px'}}>
                        {headers.slice(0, 3).map((header)=>{
                            return (
                                <TableCell align = 'center' rowSpan={2} style={{ whiteSpace: 'nowrap' , paddingTop:'5px', paddingBottom:'5px'}}>{header}</TableCell>
                            )
                        })}
                        <TableCell align = 'center' colSpan={5}>Appetite</TableCell>
                        <TableCell align = 'center' rowSpan={2}>Risk Appetite Statement</TableCell>
                    </TableRow>
                    <TableRow style={{height:'40px'}}>
                        {headers.slice(3, 8).map((header, index)=>{
                            let textcolor = 'rgba('+ (255 - index * 50) + ',' + (0 + index * 50) + ', 0, 1)'
                            return (
                                <TableCell align = 'center' rowSpan={2} style={{ whiteSpace: 'nowrap' }}>
                                    <Typography style={{color:textcolor}}>{header}</Typography>
                                </TableCell>
                            )
                        })}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {tableData.map((data)=>{
                        if (!this.state[data.No.substring(0, 2)]) {
                            return (null)
                        }
                        return (
                            <TableRow className={classes.table_rows}>
                                {headers.map((header, index)=>{
                                    if (index > 2 && index < 8) {
                                        let textcolor = 'rgba('+ (255 - (index-3) * 50) + ',' + (0 + (index-3) * 50) + ', 0, 1)'
                                        return (
                                            <TableCell>
                                                <Typography align='center' className={classes.table_cell} style={{color: textcolor }}>{data[header]}</Typography>
                                            </TableCell>
                                        )
                                    } else if (header == 'Risk Appetite Statement') {
                                        return (
                                            <TableCell align='left' className={classes.table_cell}>{data[header]}</TableCell>
                                        )
                                    } else if (header == 'Risk') {
                                        return (
                                            <TableCell align='left' className={classes.table_cell_nowrap}>{data[header]}</TableCell>
                                        )
                                    }
                                    return (
                                        <TableCell align='center' className={classes.table_cell}>{data[header]}</TableCell>
                                    )
                                })}
                            </TableRow>
                        )
                    })}
                </TableBody>
            </Table>
        )
        return (

            <div flexGrow={1}>
                {filterheader}
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <Card className={classes.cardL1}>
                            <CardContent className={classes.content}>
                                {table}
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </div>
        )
    }
}
export default withStyles(styles)(ActionPlan);


// WEBPACK FOOTER //
// ./src/components/Risks/RiskAppetite.js